import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BeneficiariesService} from '../beneficiaries.service';
import {DashboardService} from '../../../dashboard.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {AppTitleService} from '../../../app-title.service';
import {DialogInterface} from '../../utils/confirmation-dialog/confirmation-dialog.component';
import {decrypt, mobile} from 'src/app/consts/utilities';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {HttpStatusCode} from '@angular/common/http';

@Component({
    selector: 'app-beneficiaries-list',
    templateUrl: './beneficiaries-list.component.html',
    styleUrls: ['./beneficiaries-list.component.scss']
})
export class BeneficiariesListComponent implements OnInit {

    public itsFetching: boolean;
    // public dialogInterface: DialogInterface;

    @ViewChild('deleteBeneficiaryModal', { static: false })
    deleteBeneficiaryRef: TemplateRef<any>;

    public beneficiariesList: any = {
        titles: [
            {description: 'Cuenta', width: 20, direction: 'left'},
            {description: 'Tipo de Tarjeta', width: 20, direction: 'left'},
            {description: 'Nombre', width: 20, direction: 'left'},
            {description: 'Apellido Paterno', width: 20, direction: 'left'},
            {description: 'Apellido Materno', width: 20, direction: 'left'},
            {description: 'Estado', width: 20, direction: 'left'},
            {description: 'Saldo', width: 20, direction: 'left'},
            {description: '', width: 20, direction: 'left'}
        ],
        items: []
    };

    public fetchingSpinner: boolean;
    public selectedCardNo = '';

    constructor(
        private beneficiariesService: BeneficiariesService,
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private bottomSheet: MatBottomSheet,
        private route: Router,
        private titleService: AppTitleService,
    ) {
        this.titleService.setTitle('Beneficiarios');
    }

    ngOnInit() {
        this.getBeneficiariesList();
    }

    getBeneficiariesList() {
        this.itsFetching = true;

        this.beneficiariesService.getBeneficiaries().subscribe(value => {
            const { statusCode, data } = value;

            this.itsFetching = false;

            if (statusCode !== HttpStatusCode.Ok) {
                // Notify error
                return;
            }

            this.beneficiariesList.items = data;
        });
    }

    openRemoveCardModal(cardno: string): void {
        this.selectedCardNo = cardno;

        let promptRef: MatDialogRef<any> | MatBottomSheetRef = null;

        if (!mobile()) {
            promptRef = this.dialog.open(this.deleteBeneficiaryRef);
        }

        if (mobile()) {
            promptRef = this.bottomSheet.open(this.deleteBeneficiaryRef);
        }
    }

    public dismiss(): void {
        if (!mobile()) {
            this.dialog.closeAll();
        }

        if (mobile()) {
            this.bottomSheet.dismiss();
        }
    }

    public deleteBeneficiary() {
        const cardno = this.selectedCardNo;
        this.beneficiariesService.deleteBeneficiary(cardno)
            .subscribe(value => {
                const { statusCode, data } = value;

                if (statusCode !== HttpStatusCode.Ok) {
                    // Notify error
                    return;
                }

                this.dismiss();
                this.getBeneficiariesList();
            });
    }

    decrypt(value: string): string {
        return decrypt(value);
    }
}
